module.exports = __webpack_public_path__ + "static/media/004ty@4x.1fb316ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/004ty@4x.png
// module id = 411
// module chunks = 0 1